import React from 'react';
import Sparkle from './Sparkle';

const cx = (...c) => c.filter(Boolean).join(' ');

/** Small uppercase label with a sparkle. tone: light | onTint | onDark */
const Eyebrow = ({ children, tone = 'light', className }) => {
  const color = tone === 'onDark' ? 'text-amber' : 'text-ink';
  const spark = tone === 'onDark' ? '#ffb442' : '#95a8e6';
  return (
    <span className={cx('inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em]', color, className)}>
      <Sparkle size={14} color={spark} />
      {children}
    </span>
  );
};

export default Eyebrow;
